import { SxProps, Theme } from "@mui/material";

export const sxTypoHeader6: SxProps<Theme> = (theme) => ({
    width: '75px',
    color: theme.palette.secondary.light, // Set default color to secondary
    fontWeight: 'bold',
});